module.exports = __webpack_public_path__ + "img/mkt_banner_right.d0312b96.jpg";